import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VGSForm } from '../../interface/checkoutInterface';

export interface VGSFormState {
  VGSForm: VGSForm | null;
}

const initialState: VGSFormState = { VGSForm: null };

export const vgsFormSlice = createSlice({
  name: 'vgsForm',
  initialState,
  reducers: {
    setVGSForm(state, action: PayloadAction<VGSForm | null>) {
      state.VGSForm = action.payload;
    },
  },
});

export const { setVGSForm } = vgsFormSlice.actions;

export default vgsFormSlice.reducer;
